/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { capitalize } from '@veeam-vspc/core';
import { colors as palette } from '@veeam-vspc/components';

import { AgentBackupsService } from './services/agent-backups.service';
import { BaseTrendChart } from '../../../BaseTrendChart';
import { useLang } from 'views/providers/LangProvider/hooks';

export const AgentBackups: React.FC = () => {
    const lang = useLang();

    const params = {
        colors: [palette.B400, palette.Grn200],
        yTitle: lang.BACKUPS,
    };

    return (
        <BaseTrendChart
            params={params}
            service={AgentBackupsService}
            title={{ text: capitalize(lang.COMPUTER_BACKUPS) }}
        />
    );
};
